<nav class="navbar navbar-light bg-light navbar-expand-lg mb-3">
  <div class="collapse navbar-collapse" id="navbarSupportedContent">
    <ul class="navbar-nav align-items-center me-auto">
      <!--Meses -->
      <li class="nav-item d-flex align-items-center mx-2">
        <label for="monthSelect" class="me-2">Mes</label>
        <select id="monthSelect" class="form-select" [(ngModel)]="selectedMonth">
          <option *ngFor="let month of months" [value]="month">
            {{ month }}
          </option>
        </select>
      </li>
      <!-- Año -->
      <li class="nav-item d-flex align-items-center m-2">
        <label for="yearInput" class="me-2">Año</label>
        <input id="yearInput" type="number" class="form-control" [(ngModel)]="selectedYear"
          min="1900" max="2100"/>
      </li>
      <!-- Boton Consultar -->
      <li class="nav-item">
        <button class="btn btn-primary"
            (click)="updateCalendar();"><i class="fa fa-search" aria-hidden="true"></i>
        </button>
      </li>
    </ul>
  </div>
  <div class="mt-2 float-end">
    <button type="button"
      (click)="descargarHistorial()" class="btn btn-outline-primary">
    <i class="fa fa-file-excel-o" aria-hidden="true"></i> Descargar historial</button>
</div>
</nav>

<div class="container-fluid mt-4">
  <div class="spinner-container" *ngIf="loading">
    <ngx-spinner name="loading" bdOpacity=0.3bd
      Color="rgba(193,193,193,0)" size="medium" color="#185db5" type="ball-grid-beat" [fullScreen]="false">
      <p style="color: white">C a r g a n d o . . . </p>
    </ngx-spinner>
  </div>
  <table *ngIf="!loading" class="table table-bordered" style="table-layout: fixed">
    <thead>
      <tr>
        <th *ngFor="let day of days">{{ day }}</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let week of calendar">
        <td *ngFor="let day of week" class="position-relative"
          (click)="selectDate(day)"
          [ngClass]="{
            'holiday': day.isHoliday,
            'inactive': !day.isHoliday && day.detail,
            'empty': !day.date || weekend(day.date),
            'selected': selectedDate?.getDate() === day.date && selectedDate?.getMonth() === currentDate.getMonth() && selectedDate?.getFullYear() === currentDate.getFullYear()
          }">
          <div class="day position-absolute top-0 end-0 p-1 small">
            {{ day.date || '' }}
          </div>
          <div class="position-absolute top-50 start-50 translate-middle texto-truncado">
            {{ day.detail }}
          </div>
        </td>
      </tr>
    </tbody>
  </table>
</div>
